import { useNavigate } from "react-router-dom";
import successImg from "../../../public/assets/images/success-tick.png";
import { RouteConstant } from "../../util/constant/RouteConstant";

export default function PasswordChanged() {
  const navigate = useNavigate();

  function gotoLogin() {
    navigate(RouteConstant.auth.login.path);
  }
  return (
    <body>
      <div
        className="utility-page_component"
        style={{ display: "block", overflowY: "hidden" }}
      >
        <div
          className="utility-page_form-block w-form"
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "200px",
          }}
        >
          <img
            src={successImg}
            width={150}
            height={150}
            alt=""
            className="utility-page_image"
          />
        </div>
        <h3 style={{ fontWeight: "500" }}>Success</h3>
        <div
          style={{
            fontWeight: "300",
            width: "300px",
            textAlign: "center",
            marginLeft: "auto",
            marginRight: "auto",

            fontSize: "14px",
          }}
        >
          Password changed successfully
        </div>
        <a
          className="button w-button"
          style={{ width: "356px", padding: "10px", borderRadius: "10px" }}
          onClick={() => gotoLogin()}
        >
          OK
        </a>
      </div>
    </body>
  );
}
